import script from "./OptionList.vue?vue&type=script&setup=true&lang=ts"
export * from "./OptionList.vue?vue&type=script&setup=true&lang=ts"

import "./OptionList.vue?vue&type=style&index=0&id=9f8a2af8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f8a2af8"]])

export default __exports__